import React, { useEffect, useState } from 'react';
import './HeartBackground.css';

const HeartBackground = () => {
    const [hearts, setHearts] = useState([]);

    useEffect(() => {
        const interval = setInterval(() => {
            const newHeart = {
                id: Date.now(),
                left: Math.random() * 100, // Random horizontal position
                size: Math.random() * 20 + 10, // Random size between 10px and 30px
                duration: Math.random() * 5 + 5, // Random animation duration between 5s and 10s
                delay: Math.random() * 2, // Random delay
            };

            setHearts((prevHearts) => [...prevHearts, newHeart]);

            // Cleanup old hearts (adjust time based on duration)
            setTimeout(() => {
                setHearts((prevHearts) => prevHearts.filter((h) => h.id !== newHeart.id));
            }, (newHeart.duration + newHeart.delay) * 1000);

        }, 500); // Add a new heart every 500ms

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="heart-background">
            {hearts.map((heart) => (
                <div
                    key={heart.id}
                    className="heart"
                    style={{
                        left: `${heart.left}%`,
                        fontSize: `${heart.size}px`,
                        animationDuration: `${heart.duration}s`,
                        animationDelay: `${heart.delay}s`,
                    }}
                >
                    ❤️
                </div>
            ))}
        </div>
    );
};

export default HeartBackground;
